export default __webpack_public_path__ + "static/media/LogOut.36800f5d.svg";